import { WhatsNewModal } from '@odo/shared-ui';
import { CURRENT_ADMIN_RELEASE } from './releases/currentRelease';
import { videoReleaseSlides } from './releases/videoReleaseSlides';
import { useWhatsNewControls } from './whatsNewContext';

const SLIDES = videoReleaseSlides(CURRENT_ADMIN_RELEASE);

// Unmounted while closed so reopening from the sidebar starts again on the welcome slide.
export function WhatsNew() {
    const { isOpen, closeWhatsNew } = useWhatsNewControls();
    if (!isOpen) return null;

    return (
        <WhatsNewModal
            open
            slides={SLIDES}
            onDismiss={closeWhatsNew}
            finalLabel={CURRENT_ADMIN_RELEASE.finalLabel}
            showCloseButton={false}
            fixedSize
        />
    );
}
